import { render, staticRenderFns } from "./PackageActivations.vue?vue&type=template&id=71f1931a&"
import script from "./PackageActivations.vue?vue&type=script&lang=js&"
export * from "./PackageActivations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports